
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.813.031l-28 5.313c-.473.09-.813.52-.813 1v37.312c0 .48.34.91.813 1l28 5.313c.062.011.125.031.187.031.23 0 .445-.07.625-.219.23-.191.375-.484.375-.781V1c0-.297-.145-.59-.375-.781-.23-.192-.52-.242-.813-.188zM32 5v10h6v2h-6v3h6v2h-6v3h6v2h-6v3h6v2h-6v3h6v2h-6v9h12c.555 0 1-.445 1-1V18h3c1.102 0 2-.898 2-2V7c0-1.102-.898-2-2-2zM6.531 15.688h4L17.031 27c.297.508.594 1 .844 1.5h.031c-.062-.434-.093-1.293-.093-2.563v-10.25h3.5V34.25h-3.75l-6.75-11.656A15.83 15.83 0 0110 21.03h-.063c.063.657.094 1.653.094 3V34.25h-3.5zM47 20v12h1c1.102 0 2-.898 2-2v-8c0-1.102-.898-2-2-2zm0 14v12h1c1.102 0 2-.898 2-2v-8c0-1.102-.898-2-2-2z"}})])
          )
        }
      }
    